import styled from 'styled-components';

export const Message = styled.p`
  color: #ff0000;
  font-size: 26px;
`;
